var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-1"},[_c('McContactTable',{attrs:{"apiClient":_vm.query,"fields":_vm.fields,"hasData":_vm.hasData,"listDatas":_vm.employeesList,"withCard":false,"cardPadding":false,"hasEmptyState":false,"bulkCreate":_vm.isAdding,"title":_vm.$t('setting.list.notification.form.sendNotification'),"hasMargin":false,"dataStore":_vm.contactLists,"disabled":!_vm.hasAccessAll([
        'e4b-alert-center-rule-setting:update',
        'e4b-alert-center-rule-setting:create',
      ]),"hasScope":_vm.hasAccessAll([
        'e4b-alert-center-rule-setting:update',
        'e4b-alert-center-rule-setting:create',
      ])},on:{"customTag":_vm.addTag,"updateCountryCode":_vm.updateCountryCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }